<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    title="创建权益"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 文案 -->
      <a-form-item
        label="权益名称"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.name"
        />
      </a-form-item>
      <!-- 顺序 -->
      <a-form-item
        label="权益类型"
        name="type"
      >
        <a-radio-group
          v-model:value="formState.type"
        >
          <a-radio :value="1">会员</a-radio>
          <a-radio :value="2">虚拟币</a-radio>
        </a-radio-group>
      </a-form-item>
      <!-- 权益数量 -->
      <a-form-item
        label="权益数量"
        name="total_number"
        :rules="[{ required: true, validator: validatorNum }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.total_number"
        />
      </a-form-item>
      <!-- 兑换码数量 -->
      <a-form-item
        label="兑换码数量"
        name="code_number"
        :rules="[{ required: true, validator: validatorCodeNum }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.code_number"
        />
      </a-form-item>
      <!-- 失效日期 -->
      <a-form-item
        label="失效日期"
        name="expires_at"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-date-picker
          v-model:value="formState.expires_at"
          placeholder="请选择"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import dayjs from 'dayjs'
import { redeemSave } from '@/api/copyright'

// emit
const emit = defineEmits(['success'])
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 剧集信息
let formState = reactive({
  // 权益名称
  name: undefined,
  // 权益类型
  type: 1,
  // 权益数量
  total_number: undefined,
  // 兑换码数量
  code_number: undefined,
  // 失效日期
  expires_at: undefined,
})

// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    // 表单重置
    RefForm.value.resetFields()
    visible.value = false
  }
}

// 权益数量校验
function validatorNum (rule, value) {
  if (!value) {
    return Promise.reject('请输入')
  } else if (!Pub.REG_IS_POSITIVE_INTEGER(value)) {
    return Promise.reject('必须为正整数')
  }
  return Promise.resolve()
}

// 兑换码数量校验
function validatorCodeNum (rule, value) {
  if (!value) {
    return Promise.reject('请输入')
  } else if (!Pub.REG_IS_POSITIVE_INTEGER(value)) {
    return Promise.reject('必须为正整数')
  } else if (value > 20000) {
    return Promise.reject('不能大于20000')
  }
  return Promise.resolve()
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const params = {
      name: formState.name,
      type: formState.type,
      total_number: formState.total_number,
      code_number: formState.code_number,
      expires_at: dayjs(formState.expires_at).format('YYYY-MM-DD'),
    }
    redeemSave(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        // 更新父组件
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
  // width: 118px;
  // height: 148px;
  width: 208px;
  height: 124px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.upload-item-select {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
.upload-item-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 18px;
  color: #8D8D8D;
  cursor: pointer;
  opacity: 0;
}
.form-upload-item:hover .upload-item-delete {
  opacity: 1;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
</style>